declare global {
  interface Window {
    OneTrust: {
      Init: () => void
      LoadBanner: () => void
      ToggleInfoDisplay: () => void
    }
  }
}

export default defineNuxtRouteMiddleware(async () => {
  const reloadOTBanner = () => {
    if (import.meta.server) {
      return
    }

    const otConsentSdk = document.getElementById('onetrust-consent-sdk')
    if (otConsentSdk) {
      otConsentSdk.remove()
    }

    if (!window.OneTrust) {
      return
    }

    window.OneTrust.Init()
    setTimeout(() => {
      window.OneTrust.LoadBanner()

      const toggleDisplay: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName('ot-sdk-show-settings') as HTMLCollectionOf<HTMLElement>

      for (let i = 0; i < toggleDisplay.length; i++) {
        toggleDisplay[i].onclick = function (event: Event) {
          event.stopImmediatePropagation()
          window.OneTrust.ToggleInfoDisplay()
        }
      }
    }, 1000)
  }

  reloadOTBanner()
})
